export interface Province {
  id: number;
  name: string;
  type: string;
  lat: number;
  lon: number;
}

export interface WeatherData {
  temperature: number;
  windspeed: number;
  weathercode: number;
  time: string;
}

// Danh sách tọa độ một số thành phố lớn tại Việt Nam
export const PROVINCES: Province[] = [
  {
    id: 1,
    name: "Hà Nội",
    type: "Thành phố",
    lat: 21.0285,
    lon: 105.8542,
  },
  {
    id: 2,
    name: "Hồ Chí Minh",
    type: "Thành phố",
    lat: 10.7626,
    lon: 106.6602,
  },
  {
    id: 3,
    name: "Hải Phòng",
    type: "Thành phố",
    lat: 20.8449,
    lon: 106.6881,
  },
  {
    id: 4,
    name: "Đà Nẵng",
    type: "Thành phố",
    lat: 16.0544,
    lon: 108.2022,
  },
  {
    id: 5,
    name: "Cần Thơ",
    type: "Thành phố",
    lat: 10.0371,
    lon: 105.7882,
  },
  {
    id: 6,
    name: "Huế",
    type: "Thành phố",
    lat: 16.4637,
    lon: 107.5909,
  },
  {
    id: 7,
    name: "Quảng Ninh",
    type: "Tỉnh",
    lat: 20.9599,
    lon: 107.0445,
  },
  {
    id: 8,
    name: "Bắc Ninh",
    type: "Tỉnh",
    lat: 21.1861,
    lon: 106.0763,
  },
  {
    id: 9,
    name: "Thanh Hóa",
    type: "Tỉnh",
    lat: 19.8067,
    lon: 105.7767,
  },
  {
    id: 10,
    name: "Nghệ An",
    type: "Tỉnh",
    lat: 18.6734,
    lon: 105.6813,
  },
  {
    id: 11,
    name: "Hà Tĩnh",
    type: "Tỉnh",
    lat: 18.3533,
    lon: 105.9048,
  },
  {
    id: 12,
    name: "Khánh Hòa",
    type: "Tỉnh",
    lat: 12.2467,
    lon: 109.1942,
  },
  {
    id: 13,
    name: "Lâm Đồng",
    type: "Tỉnh",
    lat: 11.9404,
    lon: 108.4583,
  },
  {
    id: 14,
    name: "Đồng Nai",
    type: "Tỉnh",
    lat: 10.9574,
    lon: 106.8427,
  },
  {
    id: 15,
    name: "An Giang",
    type: "Tỉnh",
    lat: 10.5186,
    lon: 105.121,
  },
  {
    id: 16,
    name: "Cà Mau",
    type: "Tỉnh",
    lat: 9.1769,
    lon: 105.1478,
  },
  {
    id: 17,
    name: "Lai Châu",
    type: "Tỉnh",
    lat: 22.3961,
    lon: 103.4682,
  },
  {
    id: 18,
    name: "Điện Biên",
    type: "Tỉnh",
    lat: 21.3853,
    lon: 103.0135,
  },
  {
    id: 19,
    name: "Sơn La",
    type: "Tỉnh",
    lat: 21.3259,
    lon: 103.9126,
  },
  {
    id: 20,
    name: "Lào Cai",
    type: "Tỉnh",
    lat: 22.4856,
    lon: 103.9707,
  },
  {
    id: 21,
    name: "Tuyên Quang",
    type: "Tỉnh",
    lat: 21.8214,
    lon: 105.2132,
  },
  {
    id: 22,
    name: "Cao Bằng",
    type: "Tỉnh",
    lat: 22.6656,
    lon: 106.2589,
  },
  {
    id: 23,
    name: "Lạng Sơn",
    type: "Tỉnh",
    lat: 21.8415,
    lon: 106.7583,
  },
  {
    id: 24,
    name: "Thái Nguyên",
    type: "Tỉnh",
    lat: 21.5939,
    lon: 105.8442,
  },
  {
    id: 25,
    name: "Phú Thọ",
    type: "Tỉnh",
    lat: 21.3235,
    lon: 105.3346,
  },
  {
    id: 26,
    name: "Hưng Yên",
    type: "Tỉnh",
    lat: 20.6465,
    lon: 106.0511,
  },
  {
    id: 27,
    name: "Ninh Bình",
    type: "Tỉnh",
    lat: 20.2506,
    lon: 105.9745,
  },
  {
    id: 28,
    name: "Quảng Trị",
    type: "Tỉnh",
    lat: 16.7401,
    lon: 107.1852,
  },
  {
    id: 29,
    name: "Quảng Ngãi",
    type: "Tỉnh",
    lat: 15.1205,
    lon: 108.8045,
  },
  {
    id: 30,
    name: "Gia Lai",
    type: "Tỉnh",
    lat: 13.9822,
    lon: 108.0051,
  },
  {
    id: 31,
    name: "Đắk Lắk",
    type: "Tỉnh",
    lat: 12.6713,
    lon: 108.0416,
  },
  {
    id: 32,
    name: "Tây Ninh",
    type: "Tỉnh",
    lat: 11.3117,
    lon: 106.0963,
  },
  {
    id: 33,
    name: "Vĩnh Long",
    type: "Tỉnh",
    lat: 10.245,
    lon: 105.9618,
  },
  {
    id: 34,
    name: "Đồng Tháp",
    type: "Tỉnh",
    lat: 10.4574,
    lon: 105.6358,
  },
];
